export default __webpack_public_path__ + "static/team-1640f53f646bf2035d085333750a0aa8.png";